import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import useStyles from './sampleDevelopmentNl.style';
import { CheckBoxFastField } from '../../../components';

interface SamDevNlDesignFileTypeProps {
  isCrtLocked?: boolean;
}

const SampleDevelopmentNlDesignFileType: React.FC<SamDevNlDesignFileTypeProps> = (
  props,
) => {
  const { isCrtLocked = false } = props;
  const classes = useStyles();
  return (
    <Grid
      container
      spacing={1}
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
    >
      <Typography className={classes.numberTitle} display="inline">
        3. File Type
      </Typography>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={12} md={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="fileTypeTiff" label="TIFF" />
        </Grid>
        <Grid item xs={12} md={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="fileTypeEps" label="EPS" />
        </Grid>
        <Grid item xs={12} md={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="fileTypeJpg" label="JPG" />
        </Grid>
        <Grid item xs={12} md={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="fileTypePdf" label="PDF" />
        </Grid>
        <Grid item xs={12} md={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="fileTypeAi" label="AI" />
        </Grid>
        <Grid item xs={12} md={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="fileTypeQxp" label="QXP" />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SampleDevelopmentNlDesignFileType;
